import axios from "axios";
import {
	useEffect,
	useState,
	useRef,
	useLayoutEffect,
	useCallback
} from "react";
import { HeaderFooterUtils } from "shared/utils";
import Header from "./Header";

const HeaderODS = () => {
	const [headerContent, setHeaderContent] = useState("");
	const [isLoaded, setIsLoaded] = useState(false);
	const containerRef = useRef(null);
	const cssLoaded = useRef(new Set());
	const jsLoaded = useRef(new Set());

	const injectExternalScripts = useCallback((scriptUrls) => {
		scriptUrls.forEach((src) => {
			if (!document.querySelector(`script[src="${src}"]`)) {
				const scriptEl =
					document.createElement("script");
				scriptEl.src = src;
				scriptEl.defer = true;
				document.body.appendChild(scriptEl);
			}
		});
	}, []);

	const fetchData = useCallback(async () => {
		try {
			const [headerRes, resourcesRes] = await Promise.all([
				axios.get(
					process.env.NX_PUBLIC_CENTRAL_HEADER_URL
				),
				axios.get(
					process.env
						.NX_PUBLIC_CENTRAL_HEADER_HEAD_URL
				)
			]);

			let headerHtml = HeaderFooterUtils.rewriteRelativeLinks(
				headerRes.data
			);
			const resourcesHtml = resourcesRes.data;

			const linkPromises = [];
			const externalScriptUrls = new Set();

			resourcesHtml.replace(
				/<link.*?href=["'](https?:\/\/[^"']+)["']/gi,
				(_, href) => {
					if (!cssLoaded.current.has(href)) {
						const linkEl =
							document.createElement(
								"link"
							);
						linkEl.rel = "stylesheet";
						linkEl.href = href;
						document.head.appendChild(
							linkEl
						);
						cssLoaded.current.add(href);
						linkPromises.push(
							new Promise(
								(resolve) =>
									(linkEl.onload =
										resolve)
							)
						);
					}
				}
			);

			resourcesHtml.replace(
				/<script.*?src=["'](https?:\/\/[^"']+)["']/gi,
				(_, src) => {
					if (!jsLoaded.current.has(src)) {
						externalScriptUrls.add(src);
						jsLoaded.current.add(src);
					}
				}
			);

			await Promise.all(linkPromises);
			injectExternalScripts(externalScriptUrls);
			setHeaderContent(headerHtml);
			setIsLoaded(true);
		} catch (error) {
			console.error("Error loading header resources", error);
		}
	}, [injectExternalScripts]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	useLayoutEffect(() => {
		if (containerRef.current && headerContent) {
			const range = document.createRange();
			const fragment =
				range.createContextualFragment(headerContent);
			containerRef.current.innerHTML = "";
			containerRef.current.appendChild(fragment);

			containerRef.current
				.querySelectorAll("script")
				.forEach((oldScript) => {
					const newScript =
						document.createElement(
							"script"
						);
					if (oldScript.src) {
						newScript.src = oldScript.src;
						newScript.defer = true;
					} else {
						newScript.text =
							oldScript.innerHTML;
					}
					oldScript.parentNode.replaceChild(
						newScript,
						oldScript
					);
				});

			setTimeout(
				() =>
					window.document.dispatchEvent(
						new Event("DOMContentLoaded")
					),
				100
			);
		}
	}, [headerContent]);

	return isLoaded ? (
		<div
			id="app-header"
			data-qa="header-content"
			ref={containerRef}
		/>
	) : (
		<Header />
	);
};

export default HeaderODS;
